import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { Subscription } from 'rxjs';
import { DialogButtonComponent } from "../buttons/dialog-button.component";

@Component({
  standalone: true,
  imports: [DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-2xl w-full">
      <div class="p-6 w-96 max-w-full">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p>{{ modalData?.message }}</p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Rensa'"
            (onClick)="confirm()"
            variant="warning">
          </app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class CleanEventsDialogComponent implements OnDestroy {
  modalData?: {
    title: string;
    message: string;
    confirmText?: string;
    abortText?: string;
    action?: string;
  };

  private sub = new Subscription();

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: any,
    private api: AuthorizedApiService,
  ) {
    this.modalData = data;
  }

  close(value: any = false): void {
    this.modalService.close(value);
  }

  confirm(): void {
    if (this.modalData?.action === 'cleanEvents') {
      const sub = this.api.cleanEventHistory().subscribe(res => {
        console.log('Händelser rensade:', res);
        this.close(true);
      });
      this.sub.add(sub);
    } else if (this.modalData?.action === 'wipeProfile') {
      const sub = this.api.wipeProfile().subscribe(
        res => {
          console.log('Profil raderad:', res);
          this.close(true);
        },
        err => {
          console.error('Fel vid radering:', err);
          this.modalService.close(false);
        }
      );
      this.sub.add(sub);
    } else {
      this.close(false);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
